<template>
  <div id="apps" style="height:100%">
    <div id="bannerHead" style="height:10%">
      <!-- 顶部banner -->
      <el-col id="banner">
        <div id="bannerS">
          <!-- <div id="bannerFont">
            <span style="margin-right:10px">仁慈博爱</span>|
            <span style="margin-left:10px">精诚济世</span>
          </div>-->
        </div>
      </el-col>
      <!-- 顶部导航条 -->
      <el-col class="nav">
        <div style="width:1600px;" id="nav">
          <div id="bannerDiv" style="margin-right:10px;margin-top:-4px">
            <img
              id="bannerImg"
              @click="path"
              style="height:70px;width:398px"
              src="../assets/img/logo3.png"
              alt
            />
          </div>
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <!-- <el-menu-item index="0" style="width:250px;margin-right:10px" class="image">

            </el-menu-item>-->
            <el-menu-item
              :index="item.id.toString()"
              v-for="item in sectionList"
              :key="item.id"
              @click="open(item)"
              style="font-size:22px;padding:0 10px;"
            >{{item.name}}</el-menu-item>
          </el-menu>
        </div>
      </el-col>
    </div>
    <!-- <div></div> -->
    <router-view></router-view>
    <!-- 页尾 -->
    <el-col id="tab" style="height:20%">
      <div style="width:1050px;height:100%;margin: 0 auto;">
        <el-col :span="6">
          <img
            style="width:144px;height:144px;margin:20px 0 18px"
            src="../assets/img/erweima.png"
            alt
          />
        </el-col>
        <el-col class="floatText" :span="8" style="height:100%;padding-top:35px">
          <el-col style="margin-top:1vh">
            <span>主办：{{projectForm.hostName}}</span>
          </el-col>
          <el-col style="margin-top:1vh">
            <span>技术支持：{{projectForm.technicalSupport}}</span>
          </el-col>
          <el-col style="margin-top:1vh">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=5176.19720258.J_9220772140.109.7b8176f4K5hj5D" target="_blank" style="color: white;">
              <span>{{projectForm.record}}</span>
            </a>
          </el-col>
          <el-col style="margin-top:1vh">
            <a href="https://beian.miit.gov.cn/?spm=5176.19720258.J_9220772140.110.7b8176f4K5hj5D#/Integrated/index" target="_blank" style="color: white;">
              <span>{{projectForm.icp}}</span>
            </a>
          </el-col>
        </el-col>
        <el-col class="floatText" :span="10" style="height:100%;padding-top:35px">
          <el-col style="margin-top:1vh">
            <span>地址：{{projectForm.address}}</span>
          </el-col>
          <el-col style="margin-top:1vh">
            <span>邮编：{{projectForm.postcode}}</span>
          </el-col>
          <el-col style="margin-top:1vh">
            <span>急救电话：{{projectForm.emergencyPhone}}</span>
          </el-col>
          <el-col style="margin-top:1vh">
            <span>服务热线：{{projectForm.hotLine}}</span>
          </el-col>
        </el-col>
      </div>
    </el-col>
  </div>
</template>
<script>
import { projectInfo } from "../../api/api.js";

export default {
  data() {
    return {
      activeIndex: "1",
      sectionList: [],
      projectForm: {}
    };
  },
  created() {
    this.getProjectInfo();
  },
  watch: {
    $route(to, from) {
      if (to.path == "/") {
        this.activeIndex = "1";
      } else if (to.path == "/Survey") {
        this.activeIndex = "2";
      }
    }
  },
  methods: {
    getProjectInfo() {
      projectInfo({ id: "4028838871f728140171f7ff549a0001" }).then(res => {
        if (res.data.code === 200) {
          this.$store.commit("SET_PROJECTINFO", res.data.data);
          this.sectionList = res.data.data.sectionList;
          console.error(this.sectionList)

          this.projectForm = res.data.data.projectForm;
          this.sectionList[0].url = "/";
          // 组装信息
          sessionStorage.setItem(
            "sectionList",
            JSON.stringify(this.sectionList)
          );
          sessionStorage.setItem(
            "courtyard",
            JSON.stringify(res.data.data.courtyard)
          );
          sessionStorage.setItem(
            "divisionList",
            JSON.stringify(res.data.data.divisionList)
          );
          sessionStorage.setItem(
            "doctorBossList",
            JSON.stringify(res.data.data.doctorBossList)
          );
          sessionStorage.setItem(
            "doctorForms",
            JSON.stringify(res.data.data.doctorForms)
          );
          sessionStorage.setItem(
            "doctorList",
            JSON.stringify(res.data.data.doctorList)
          );
          sessionStorage.setItem(
            "projectForm",
            JSON.stringify(res.data.data.projectForm)
          );
        }
      });
    },
    path() {
      this.$router.push({ path: "/" });
    },
    toICP() {
      window.open("http://www.beian.gov.cn/", "_blank");
    },
    open(data) {
      // if (data.url === 'home1'){
      //   this.$router.push({ path: "/"})
      // }
      // console.log(data)
      // if(data.url == '/'){
      // this.$router.push({path:'/'})
      // }else{
      this.$router.push({ path: data.url, params: { data: data.children } });
      console.log(data)

      // }
    }
  }
};
</script>
<style lang="less" scoped>
#tab {
  height: 190px;
  width: 100%;
  background-image: url(../assets/img/footer-img1.jpg);
  color: white;
  // margin-top: 33px;
}
#app {
  position: relative;
}
#apps .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  color: rgba(4, 44, 78, 1);
}
#apps .el-menu.el-menu--horizontal {
  border-bottom: none;
}
#apps .el-menu-item {
  border-bottom-color: transparent !important;
}

@font-face {
  font-family: "MyFont";
  src: url(../assets/font/W7.ttf);
}
.el-menu-item {
  font-family: MyFont;
  font-size: 25px;
}
#banner {
  height: 3.3vh;
  width: 100%;
  font-size: 26px;
  line-height: 3.5vh;
  font-weight: 600;
  color: #ffffff;
  background: url(../assets/img/banner.png);
  background-size: 100% 100%;
  #bannerS {
    width: 100%;
    margin: 0 auto;
    position: relative;
    font-family: MyFont;
    #bannerFont {
      background-color: #0574a8;
      width: 300px;
      text-align: center;
      position: absolute;
      right: 96px;
    }
  }
}
#nav > ul {
  background: rgba(255, 255, 255, 0);
}
#nav {
  margin: 8px auto;
  // padding: 0 auto;
  display: flex;
  flex-direction: row;
}
.nav {
  width: 100%;
  height: 80px;
  background-color: #dfd6c7;
  background-image: url(../assets/img/1121.png);
}
#bannerHead {
  background-image: url(../assets/img/1121.png);
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: rgba(255, 255, 255, 0);
  color: #042c4e;
}
.el-menu--horizontal > .el-menu-item {
  color: #5d070c;
}
</style>
<style lang="less">
@font-face {
  font-family: 'dasongbiao';
  src: url(../assets/font/SourceHanSerifTC-SemiBold.otf) format("opentype");
}
html,
body {
  margin: 0;
  padding: 0;
  // height: 100%!important;
  min-width: 1300px;
}
@media screen and (max-width: 1680px) {
  #bannerDiv {
    margin-right: 80px !important;
    padding-top: 0.1vh !important;
  }
  // #bannerImg{
  //   height:60px !important;
  //   width: 220px !important;
  // }
  #tab {
    // height: 130px !important;
    img {
      height: 140px !important;
      width: 140px !important;
      margin: 20px 0 18px 18px !important;
    }
  }
  // 首页方块标签
  #nav {
    width: 1600px !important;
  }
  #About {
    // height: 430px !important;
    .about {
      top: 240px !important;
    }
    #survey,
    #survey1,
    #survey2,
    #survey3 {
      width: 150px !important;
      height: 150px !important;
      font-size: 50px;
      div {
        margin-top: 20px !important;
      }
    }
    #survey,
    #survey2 {
      left: 20% !important;
    }
    #survey {
      top: 140px !important;
    }
    #survey1 {
      top: 253px !important;
      left: 0px !important;
    }
    #survey2 {
      top: 300px !important;
    }
    #survey3 {
      left: 40% !important;
    }
  }
}
@media screen and (max-width: 1500px) {
  #bannerImg {
    padding-top: 0.2vh !important;
  }
  #nav {
    width: 1400px !important;
  }
}
@media screen and (max-width: 1600px) {
  // 首页
  #nav {
    width: 1400px !important;
  }
  #bannerDiv {
    margin-right: 80px !important;
    margin-top: 2px !important;
    // padding-top: 0.3vh !important;
  }
  #bannerImg {
    height: 55px !important;
    width: 280px !important;
  }
  #banner {
    height: 24px !important;
    width: 100%;
    font-size: 16px !important;
    line-height: 24px !important;
    background-size: 100% 100% !important;
  }
  .nav {
    height: 60px !important;
    #nav {
      margin: 0 auto;
      .el-menu-item {
        font-size: 20px !important;
      }
      .image {
        // img {
        //   height: 40px !important;
        //   width: 80% !important;
        // }
      }
    }
  }
  // 首页方块标签
  #About {
    // height: 430px !important;
    .about {
      top: 150px !important;
    }
    #survey,
    #survey1,
    #survey2,
    #survey3 {
      width: 150px !important;
      height: 150px !important;
      font-size: 50px;
      div {
        margin-top: 2vh !important;
      }
    }
    #survey,
    #survey2 {
      left: 20% !important;
    }
    #survey {
      top: 140px !important;
    }
    #survey1 {
      top: 253px !important;
      left: 0px !important;
    }
    #survey2 {
      top: 300px !important;
    }
    #survey3 {
      left: 40% !important;
    }
  }
  #tab {
    // height: 130px !important;
    img {
      height: 110px !important;
      width: 110px !important;
      margin: 20px 0 18px !important;
    }
  }
  .floatText {
    padding-top: 15px !important;
    font-size: 12px !important;
  }
}

@media screen and (max-width: 1366px) {
  // 首页\
  #nav {
    width: 1300px !important;
  }
  #bannerDiv {
    margin-right: 40px !important;
    margin-top: 0 !important;
    // padding-top: 0.3vh !important;
  }
  #banner {
    height: 24px !important;
    width: 100%;
    font-size: 16px !important;
    line-height: 24px !important;
    background-size: 100% 100% !important;
  }
  .nav {
    height: 60px !important;
    #nav {
      margin: 0 auto;
      .el-menu-item {
        font-size: 20px !important;
      }
      .image {
        // img {
        //   height: 40px !important;
        //   width: 230px !important;
        // }
      }
    }
  }
  // 首页方块标签
  #About {
    // height: 430px !important;
    .about {
      top: 100px !important;
    }
    #survey,
    #survey1,
    #survey2,
    #survey3 {
      width: 120px !important;
      height: 120px !important;
      font-size: 40px;
      div {
        margin-top: 2vh !important;
      }
    }
    #survey,
    #survey2 {
      left: 20% !important;
    }
    #survey {
      top: 120px !important;
    }
    #survey1 {
      top: 213px !important;
      left: 32px !important;
    }
    #survey2 {
      top: 250px !important;
    }
    #survey3 {
      left: 36% !important;
    }
  }
  #tab {
    // height: 130px !important;
    img {
      height: 110px !important;
      width: 110px !important;
      margin: 4px 18px !important;
    }
  }
  .floatText {
    padding-top: 15px !important;
    font-size: 12px !important;
  }
}
#breadcrumb {
  position: absolute;
  left: 17%;
  top: 170px;
  font-size: 15px;
  z-index: 999;
  clear: both;
}
</style>
